// extracted by mini-css-extract-plugin
module.exports = {"onboardingRightblock":"RightBlock_onboardingRightblock__1SLFM"};